export const publicBrandColors = {
  50: "#E6F0FF",
  100: "#C8DCFF",
  200: "#9DBFFF",
  300: "#72A3FF",
  400: "#4A88FF",
  500: "#1F6AFF",
  600: "#1553CC",
  700: "#0D3C99",
  800: "#072666",
  900: "#031233",
};

export const adminBrandColors = {
  50: "#E8FAFC",
  100: "#C6F3F5",
  200: "#9EE7EC",
  300: "#6DD5DF",
  400: "#3CBDD0",
  500: "#1BA6BA",
  600: "#148595",
  700: "#0F6772",
  800: "#09464D",
  900: "#042A2F",
};

export const teacherBrandColors = {
  50: "#F3EEFF",
  100: "#E4D9FF",
  200: "#C9B6FF",
  300: "#A991FF",
  400: "#8A6EFF",
  500: "#6E4CFF",
  600: "#563BCC",
  700: "#3D2A99",
  800: "#271966",
  900: "#150C33",
};

export const staffBrandColors = {
  50: "#FFF3E6",
  100: "#F7DFC2",
  200: "#EEC79A",
  300: "#DDA86B",
  400: "#C88A45",
  500: "#B36F2A",
  600: "#8F5720",
  700: "#6A4017",
  800: "#452A0E",
  900: "#241607",
};

interface BrandFlags {
  isAdmin?: boolean;
  isTeacher?: boolean;
  isStaff?: boolean;
  isMember?: boolean;
}

export function getBrandColors({
  isAdmin = false,
  isTeacher = false,
  isStaff = false,
  isMember = false,
}: BrandFlags) {
  let selected = publicBrandColors;

  if (isAdmin) {
    selected = adminBrandColors;
  } else if (isTeacher) {
    selected = teacherBrandColors;
  } else if (isStaff) {
    selected = staffBrandColors;
  }

  return {
    brand: selected,
    brandScheme: selected,
    brandTabs: selected,
  };
}
